module.exports = __webpack_public_path__ + "static/img/huichangbuju.d744f27.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/huichangbuju.jpg
// module id = wfA9
// module chunks = 1